export class DragDropItemEventDto {
  event: any;
  componentType: DragDropItemComponentType;
  ScopingItemId: number;
}

export enum DragDropItemComponentType {
  ScopingItem,
  DependentItem
}
